const PUBLIC_LOGIN_PATH = '/login';

/** Marketing site + auth screens — no session probe / no forced login redirect. */
const AUTH_EXEMPT_PUBLIC_PREFIXES = [
  '/product',
  '/partners',
  '/how-we-work',
  '/security',
  '/integrations',
  '/for-manufacturing',
  '/privacy',
  '/terms',
  '/guides',
] as const;

const AUTH_EXEMPT_PUBLIC_EXACT = new Set([
  '/',
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
]);

function normalizePathname(pathname: string | null | undefined): string {
  if (!pathname) {
    return '';
  }
  return pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

export function isPublicLoginRoute(pathname: string | null | undefined): boolean {
  return normalizePathname(pathname) === PUBLIC_LOGIN_PATH;
}

/** @deprecated Use isPublicLoginRoute */
export function isPublicSerbianRoute(pathname: string | null | undefined): boolean {
  return isPublicLoginRoute(pathname);
}

export function isLandingRoute(pathname: string | null | undefined): boolean {
  const path = normalizePathname(pathname);
  return path === '/' || path === '';
}

/**
 * Public marketing/auth routes where a stale JWT must not trigger settings load,
 * token-refresh noise, or redirect to /login.
 */
export function isAuthExemptPublicRoute(pathname: string | null | undefined): boolean {
  const path = normalizePathname(pathname);
  if (!path || AUTH_EXEMPT_PUBLIC_EXACT.has(path)) {
    return true;
  }
  return AUTH_EXEMPT_PUBLIC_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}
